/* src/app/pages/ui-kit/components/toggle-switch-view/toggle-switch-view.component.scss */
.box {
  padding: 1rem;
  border: 1px solid 16px;
  border-radius: 8px;
  margin-bottom: 1rem;
  background: var(--contrast-inverse);
}
/*# sourceMappingURL=toggle-switch-view.component.css.map */
